import script from "./Category1688.vue?vue&type=script&lang=ts&setup=true"
export * from "./Category1688.vue?vue&type=script&lang=ts&setup=true"

import "./Category1688.vue?vue&type=style&index=0&id=6d089198&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d089198"]])

export default __exports__